import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-tab' })
export class TabComponent {

    private labels: HTMLElement[];
    private tabs: HTMLElement[];

    constructor(private element: HTMLElement) {
        this.labels = Array.from(this.element.querySelectorAll('.c-tab__label'));
        this.labels.forEach(label => label.addEventListener('click', () => this.changeTab(label)));

        this.tabs = Array.from(this.element.querySelectorAll('.c-tab__content'));
	}

    private changeTab(label: HTMLElement): void {
        this.labels.forEach(label => label.classList.remove('is-active'));
        this.tabs.forEach(tab => tab.classList.remove('is-active'));

        label.classList.add('is-active');
        this.element.querySelector(`#${label.dataset.tab}`).classList.add('is-active');
    }

}
